import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
export var GET_CMS_PAGE = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query GetCmsPage($identifier: String!) {\n        cmsPage(identifier: $identifier) {\n            url_key\n            content\n            content_heading\n            title\n            page_layout\n            meta_title\n            meta_keywords\n            meta_description\n        }\n    }\n"])));
export default {
  getCMSPageQuery: GET_CMS_PAGE
};